import { FleetTruckLocation } from '@numeo/types'
import { TruckActivityStatus } from '@numeo/types-core'

export function hasValidFleetTruckCoordinates(fleetTruck: Pick<FleetTruckLocation, 'coordinates'>): boolean {
    return fleetTruck.coordinates?.lat !== 0 && fleetTruck.coordinates?.lng !== 0
}

export function resolveFleetTruckConnected(fleetTruck: Pick<FleetTruckLocation, 'activityStatus' | 'coordinates'>): boolean {
    if (fleetTruck.activityStatus === TruckActivityStatus.ACTIVE) {
        return true
    }

    if (fleetTruck.activityStatus === TruckActivityStatus.INACTIVE) {
        return false
    }

    return hasValidFleetTruckCoordinates(fleetTruck)
}
